import { useContext } from 'react';
import { GcalContext } from '../context';
import { IGcalContext } from '..';

/**
 * Returns Gcal context
 */
export function useGcal(): IGcalContext {
  return useContext(GcalContext);
}
